<template>
  <div>
    <table v-if="!isLoading" class="organization-table">
      <tr>
        <th v-if="tableFor == 'top5'" :class="organizationType">N°</th>
        <th :class="organizationType" class="main-title">
          {{ organizationType == "buyer" ? "Compradores" : "Vendedores" }}
        </th>
      </tr>

      <tr v-for="(item, index) in tableRows" :key="index">
        <td v-if="tableFor == 'top5'">
          {{ item.rankingPosition }}
        </td>
        <td>{{ item.organization.businessName }}</td>
      </tr>
    </table>

    <div v-show="isLoading">
      <div ref="loader" class="vs-con-loading__container div-with-loading">
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { print } from "graphql";

import organizationRankingDashboardQuery from "../../graphql/queries/organizationRankingDashboard.gql";
import lastOperationsOrganizationsDashboardQuery from "../../graphql/queries/lastOperationsOrganizationsDashboard.gql";

export default {
  props: {
    tableFor: {
      type: String, // ["top5","recent"]
      required: true,
    },

    organizationType: {
      type: String, // ["buyer", "seller"]
      required: true,
    },

    fastFilter: {
      type: String,
      required: false,
      default: "last_3_months",
    },
  },

  data() {
    return {
      tableRows: [],
      isLoading: true,
    };
  },
  beforeMount() {
    this.getTableData();
  },

  mounted() {
    this.$vs.loading({
      container: this.$refs.loader,
      scale: 1,
      background: "white",
    });
  },
  watch: {
    fastFilter: function () {
      this.getTableData();
    },
  },
  methods: {
    getTableData() {
      if (this.tableFor == "top5") {
        this.getDataByQuery(
          organizationRankingDashboardQuery,
          "organizationRankingDashboard"
        );
      }

      if (this.tableFor == "recent") {
        this.getDataByQuery(
          lastOperationsOrganizationsDashboardQuery,
          "lastOperationsOrganizationsDashboard"
        );
      }
    },

    getDataByQuery(query, queryName) {
      this.isLoading = true;
      axios
        .get(`${process.env.VUE_APP_GRAPH_PATH}`, {
          params: {
            query: print(query),
            variables: {
              currentUserToken: localStorage.getItem("USER_TOKEN"),
              organizationType: this.organizationType,
              fastFilter: this.fastFilter,
            },
          },
        })
        .then((rta) => {
          if (!rta.data.errors) {
            this.tableRows = rta.data.data[`${queryName}`];
            this.isLoading = false;
          } else {
            this.tableRows = [];
          }
        });
    },
  },
};
</script>

<style scoped>
.div-with-loading {
  width: 80px;
  height: 80px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 0;
}
.organization-table {
    margin-top: 15px;
    border-collapse: collapse;
    width: 100%;
}

.organization-table td,
.organization-table th {
  padding: 3px;
}

.organization-table tr:nth-child(even) {
  background-color: #f8f8f8;
}

.organization-table tr:hover {
  background-color: #ddd;
}

.seller {
  background-color: #e6a382;
  color: white;
}
.buyer {
  background-color: #527da1;
  color: white;
}
</style>